import React, { useState, useEffect } from 'react';
import { useStore } from 'store';
import { Row, Col, Button } from 'react-bootstrap';
import { Modal, ErrorModal } from 'components';
import { hideLoader, showLoader } from 'store/actions/commons';
import {postValidateExcel} from 'services/rsvp/getRSVP';
import verifica from 'assets/img/verifica.png';
import cirulo_error from 'assets/img/cirulo_error.png';

const TemplateUpload = ({typeId , handleNextStepsFather, handleUrlFather, handleTimeSleepFather }) => {

    const [show, setShow] = useState(false);
    const [, dispatch] = useStore((state) => state.giftTable.giftTable);
    const [base64Data, setBase64Data] = useState(null);
    const [nombreArchivo, setNombreArchivo] = useState(null);
    const [jsonResultado, setJsonResultado] = useState(null);
    const [showTrueModal, setShowTrueModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);


    const handleUpExcel = () => {
        setShow(true);
    };

    const handleCloseUpload = () => {
        setShow(false);
    };

    const handleClickConfirm = () => {
         handleNextStepsFather();
        setShowTrueModal(false);
    };

    const handleClose = () => {
        setShowErrorModal(false);
        setShowTrueModal(false);
    };

    const handleClickError = () => {
        setShowErrorModal(false);;
    };

//console.log('typeId en hijo : ',typeId);

    const handleSubmit = () => {
        dispatch(showLoader());
        if(base64Data) {

        console.log('Nombre archivo: ',nombreArchivo);
        console.log('archivo: ',base64Data)

        const nuevoRegistro = {
            typeId,
            nombreArchivo,
            base64Data
        };

        setJsonResultado(nuevoRegistro);
        setShow(false);

        } else {
            alert('Seleccione el archivo a cargar');
            dispatch(hideLoader());
        }
    };

    const handleFileChange = (e) => {
        console.log('Convirtiendo archivo a base 64 ');
        const file = e.target.files[0];

        if (file) {
        // Crear un objeto FileReader
        const reader = new FileReader();

        setNombreArchivo(file.name);
       // setTypeId(tableInfo?.evento);

        // Configurar el evento onload del lector de archivos
        reader.onload = (event) => {
            // El resultado del lector de archivos es el contenido en base64
            const base64 = event.target.result;
            setBase64Data(base64);
        };

        // Leer el archivo como base64
        reader.readAsDataURL(file);
        }
    };

    useEffect(() => {
        //    ENVIAR DATA A SERVICIO CARGA EXCEL
        if(jsonResultado) {
        console.log('jsonResultado en hijo ',jsonResultado);

        // Valida la respuesta del backend    -----------------------------------------------------
        postValidateExcel(typeId, jsonResultado).then((valorDeServicio) => {
          console.log('postValidateExcel ', valorDeServicio);
          if(valorDeServicio?.data?.status === 'success') {
            setShowTrueModal(true);
            handleUrlFather(valorDeServicio?.data);
            handleTimeSleepFather(valorDeServicio?.data?.seg)
          }else{
            console.log('Archivo sube mal ');
            setShowErrorModal(true);
            console.log('Errores al subir el acrhivo: ', valorDeServicio?.data?.detalle_errors)
          }

          // Valida la respuesta del backend
          dispatch(hideLoader());

        });

        }
    }, [jsonResultado]);

    return (
        <>
        <Button
            id={22}
            block
            variant="primary"
            onClick={handleUpExcel}
            type="button"
            className={''}>
            Subir plantilla
        </Button>

        <Modal
            size="lg"
            title=""
            titleHeader="Subir plantilla"
            titleHeaderClassName="col-md-6 offset-md-3"
            show={show}
            onClose={handleCloseUpload}
            //className={styles.uploadImageModal}
            onSubmit={handleSubmit}
            actionLabel="Subir foto"
            variant="completed"
            variantOnlyInMobile
            showCancel = {false}
            withHeader = {true}
            >
            <Row className="pb-4">
                <Col xs={12}  className="d-flex justify-content-center align-items-center">
                <input type="file" accept=".xlsx" onChange={handleFileChange} />
                </Col>
            </Row>
        </Modal>

        <ErrorModal
            show={showTrueModal}
            title=""
            titleHeader=""
            icon={verifica}
            titleHeaderClassName="col-md-12 offset-md-3"
            actionLabel="Entendido"
            onAction={handleClickConfirm}
            onClose={handleClose}
            closeLabel = 'Entendido'
            type={''}
            subtitle={
            <p className="text-center">
                <b>¡Tu archivo se subió<br />con exito!<br /></b>
            </p>
            }
        />

        <ErrorModal
            show={showErrorModal}
            title=""
            titleHeader=""
            icon={cirulo_error}
            titleHeaderClassName="col-md-12 offset-md-3"
            actionLabel="Entendido"
            onAction={handleClickError}
            onClose={handleClose}
            closeLabel = 'Entendido'
            type={''}
            subtitle={
            <p className="text-center">
                <h2><b>¡Hubo un error al<br />cargar tu archivo!</b></h2><br/>Formato erróneo<br />
            </p>
            }
        />
    </>
    );
};

export default TemplateUpload;